import './App.css';
import { Route, Routes } from "react-router-dom"
import Privacy from './privacy';
import PrivacyNew from "./privacyNew";

function App() {
  return (
      <Routes>
        <Route path="/" element={<Privacy name="Nivo" />} />
        <Route path="/ace" element={<Privacy name="Ace Solutions" />} />
        <Route path="/autarky" element={<Privacy name="Autarky" />} />
        <Route path="/cls" element={<Privacy name="CLS Money" />} />
        <Route path="/coop" element={<Privacy name="The Co-operative Bank Business Help" />} />
        <Route path="/crystal" element={<Privacy name="Crystal Specialist Finance" />} />
        <Route path="/evolution" element={<Privacy name="Evolution Money" />} />
        <Route path="/loanable" element={<Privacy name="Loanable" />} />
        <Route path="/love" element={<Privacy name="Love Finance" />} />
        <Route path="/mfs" element={<Privacy name="Market Financial Solutions" />} />
        <Route path="/me" element={<Privacy name="Mortgage Experience" />} />
        <Route path="/mortgagehut" element={<Privacy name="Mortgage Hut" />} />
        <Route path="/ocean" element={<Privacy name="Ocean" />} />
        <Route path="/pepper" element={<Privacy name="Pepper" />} />
        <Route path="/sbs" element={<Privacy name="Scottish Building Society" />} />
        <Route path="/selina" element={<Privacy name="Selina Finance" />} />
        <Route path="/sercle" element={<Privacy name="Sercle" />} />
        <Route path="/stepone" element={<Privacy name="Step One" />} />
        <Route path="/time" element={<Privacy name="Time Finance" />} />
        <Route path="/together" element={<Privacy name="Together Money" />} />
        <Route path="/utb" element={<Privacy name="United Trust Bank" />} />
        <Route path="/atl" element={<Privacy name="ATL Global" />} />
        <Route path="/wtbsn" element={<PrivacyNew name="When The Bank Says No" email="hello@whenthebanksaysno.co.uk" policyLink="https://www.whenthebanksaysno.co.uk/privacy-policy/" />} />
        <Route path="/firenze" element={<PrivacyNew name="Firenze" policyLink="https://www.firenzeme.com/privacypolicy" email="support@firenzeme.com" />} />
        <Route path="/ethos" element={<PrivacyNew name="Ethos Assest Finance" policyLink="https://www.ethosfinance.co.uk/privacy-policy-terms-of-business/" email="ethosassetfinanceltd@gmail.com" />} />
        <Route path="/lendingexpert" element={<PrivacyNew name="Lending Expert" policyLink="https://www.lendingexpert.co.uk/privacy-policy/" email="contact@lendingexpert.co.uk"/>} />
        <Route path="/perotto" element={<Privacy name="Perotto" />} />
        <Route path="/p1" element={<PrivacyNew name="P1 Lombard Loan" policyLink="https://www.firenzeme.com/privacypolicy" email="support@firenzeme.com" />} />
        <Route path="/hopecapital" element={<Privacy name="Hope Capital"/>}/>
        <Route path="/accredo" element={<Privacy name="Accredo"/>}/>
      </Routes>
  );
}

export default App;
